module.exports = __webpack_public_path__ + "img/grijs.13ff01a9.jpg";